import { KatIcon } from "@amzn/katal-react";
import classNames from "classnames";
import styles from "src/components/Pages/DocumentInbound/DocumentComplianceHelper/styles.module.scss";
import { useTranslation } from "react-i18next";
import {
  ComplianceHelperField,
  getLocationText,
} from "./document-compliance-helper-extractor";
import { ValidationRuleSeverity } from "src/api/interfaces/document_validation";
import React from "react";

const TRANSLATION_KEYS = {
  ERROR_COUNT: "aic_doc_page_inbound_document_compliance_helper_error_count",
  LOCATION: "aic_doc_page_inbound_document_compliance_helper_location",
  ERROR_CRITICAL:
    "aic_doc_page_inbound_document_compliance_helper_error_critical",
  ERROR_SEVERE: "aic_doc_page_inbound_document_compliance_helper_error_severe",
  ERROR_WARNING:
    "aic_doc_page_inbound_document_compliance_helper_error_warning",
  ERROR_INFO: "aic_doc_page_inbound_document_compliance_helper_error_info",
};

interface ComplianceErrorItemProps {
  item: ComplianceHelperField;
  index: number;
  onClick: () => void;
}

const ComplianceErrorItem: React.FC<ComplianceErrorItemProps> = ({
  item,
  index,
  onClick,
}) => {
  const { t } = useTranslation();
  const count = item.fields.length;
  const location = getLocationText(item.fields, t);

  const getSeverityData = () => {
    switch (item.severity) {
      case ValidationRuleSeverity.CRITICAL.valueOf():
        return {
          css: styles.critical,
          translation: TRANSLATION_KEYS.ERROR_CRITICAL,
        };
      case ValidationRuleSeverity.SEVERE.valueOf():
        return {
          css: styles.severe,
          translation: TRANSLATION_KEYS.ERROR_SEVERE,
        };
      case ValidationRuleSeverity.ERROR.valueOf():
        return {
          css: styles.severe,
          translation: TRANSLATION_KEYS.ERROR_SEVERE,
        };
      case ValidationRuleSeverity.WARNING.valueOf():
        return {
          css: styles.warning,
          translation: TRANSLATION_KEYS.ERROR_WARNING,
        };
      default:
        return { css: "", translation: TRANSLATION_KEYS.ERROR_INFO };
    }
  };

  const severityData = getSeverityData();

  return (
    <div
      key={index}
      className={classNames(styles.error_item)}
      onClick={onClick}
    >
      <div className={classNames(styles.error_header, severityData.css)}>
        <KatIcon name="info-circle-fill" size="small" />
        <span>
          {count}{" "}
          {t(TRANSLATION_KEYS.ERROR_COUNT, {
            severity: t(severityData.translation),
          })}
        </span>
      </div>
      <div className={classNames(styles.error_location)}>
        {t(TRANSLATION_KEYS.LOCATION)}: {location}
      </div>
    </div>
  );
};

export default ComplianceErrorItem;
